import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import PublicIcon from '@material-ui/icons/Public';
import { createElement } from 'react';
import { ksdpGrrReadPermission } from '@internal/ksdp-permissions-common';
import { guardKsdpPage } from '@internal/ksdp-permissions-react';

const grrDashboardPage = PageBlueprint.make({
  name: 'grr',
  params: {
    path: '/grr',
    title: 'Local Security',
    icon: createElement(PublicIcon),
    // Loaded on first visit so the map library and geometry stay out of the app's
    // startup bundle; the snapshot itself is fetched from grr-dashboard-backend.
    loader: async () => {
      const { GrrDashboard } = await import('./components/GrrDashboard');
      return guardKsdpPage(ksdpGrrReadPermission, createElement(GrrDashboard));
    },
  },
});

export const grrDashboardPlugin = createFrontendPlugin({
  pluginId: 'grr',
  extensions: [grrDashboardPage],
});
